import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('AppHeader').create(() => ({
  root: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '10px',
    width: '90%',

    zIndex: '1',
    '&[data-glowing="true"]': {
      '&:after': {
        content: '""',
        width: '90%',
        height: '200%',
        borderRadius: '50%',
        backgroundColor: '#1993DB40',
        position: 'absolute',
        top: '0',
        zIndex: '-99',
        filter: 'blur(90px)',
      },
    },
  },

  infoIcon: {
    width: '100%',
    height: '100%',
    border: '1px solid #FFFFFF17',
  },
  info: {
    width: '32px',
    height: '32px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    // border: '1px solid #FFFFFF17',
    backgroundColor: '#FFFFFF17',
    padding: '8px',
    cursor: 'pointer',
  },

  avatar: {
    cursor: 'pointer',
    '&[data-isplus="true"]': {
      border: '2.5px solid rgba(74, 107, 252, 0.6)',
      borderRadius: '9999px',
      boxShadow: '0px 0px 20px 0px rgba(74, 107, 252, 0.6);',
    },
  },
}))
